import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { HttpClientService } from './http-client.service';
import { ReadPec } from './models';

@Injectable({
  providedIn: 'root',
})
export class EmailContentService {
  readPec: ReadPec;
  envelopeLoading = false;
  fileLoading = false;
  envelopeDownloadError = false;
  fileDownloadError = false;

  constructor(private httpClientService: HttpClientService) {}

  downloadEnvelope(token: string): void {
    if (this.envelopeLoading) {
      return;
    }
    this.envelopeDownloadError = false;
    this.fileDownloadError = false;
    this.envelopeLoading = true;
    const envelopeObservable = this.httpClientService.downloadEnvelop(
      token
    );
    envelopeObservable
      .pipe(
        take(1),
        tap((base64file) => {
          this.downloadBase64File(base64file, 'plain/text', 'Busta.eml');
          this.envelopeLoading = false;
        }),
        catchError((err) => {
          this.envelopeDownloadError = true;
          this.envelopeLoading = false;
          return throwError(err);
        })
      )
      .subscribe();
  }

  downloadFile(attachmentId: string, filename: string, token: string): void {
    if (this.fileLoading) {
      return;
    }
    this.envelopeDownloadError = false;
    this.fileDownloadError = false;
    this.fileLoading = true;
    const fileObservable = this.httpClientService.downloadFile(
      token,
      attachmentId,
      filename
    );
    fileObservable
      .pipe(
        take(1),
        tap((base64file) => {
          this.openBase64File(base64file, 'application/pdf');
          this.fileLoading = false;
        }),
        catchError((err) => {
          this.fileDownloadError = true;
          this.fileLoading = false;
          return throwError(err);
        })
      )
      .subscribe();
  }

  downloadBase64File(
    b64Data: string,
    mimeType: string,
    fileName: string
  ): void {
    const byteCharacters = atob(b64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
      return;
    }
    const data = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = data;
    link.download = fileName;
    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  openBase64File(b64Data: string, mimeType: string): void {
    const byteCharacters = atob(b64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
      return;
    }
    const data = window.URL.createObjectURL(blob);
    location.href = data;
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 100);
  }
}
